import { render, staticRenderFns } from "./company-case-detail.vue?vue&type=template&id=2160f771&scoped=true"
import script from "./company-case-detail.vue?vue&type=script&lang=js"
export * from "./company-case-detail.vue?vue&type=script&lang=js"
import style0 from "./company-case-detail.vue?vue&type=style&index=0&id=2160f771&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2160f771",
  null
  
)

export default component.exports